import apiClient from '@/api'

const fetchJobs = async () => {
  try {
    const response = await apiClient.get('/jobs/');
    return response.data;
  } catch (error) {
    console.error('Error fetching jobs:', error);
    throw error;
  }
};

const fetchSiteStats = async () => {
  try {
    const response = await apiClient.get('/stats/site_stats/');
    return response.data;
  } catch (error) {
    console.error('Error fetching site statistics:', error);
    // Return default values if API call fails
    return {
      jobseekers: 0,
      jobs: 0,
      companies: 0
    };
  }
};

// Export both the client and the functions
export { fetchJobs, fetchSiteStats, apiClient }
export default apiClient